<template>
  <section class="section container pt-0">
    <campaign-datatable />
  </section>
</template>

<script>
import CampaignDatatable from "./campaign_datatable/Index.vue";
export default {
  name: "CampaignIndex",
  components: {
    CampaignDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
